
import {
  computed, defineComponent, onMounted, onUnmounted, ref,
} from 'vue';
/* eslint-disable import/no-cycle */
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';
import AppLoader from '@/components/UI/AppLoader.vue';
import SpacesGroupDesc from '@/modules/spaces/components/SpacesGroupDesc.vue';
import router from '@/router';
import AppSearch from '@/components/UI/AppSearch.vue';

export default defineComponent({
  components: {
    AppLoader,
    SpacesGroupDesc,
    AppSearch,
  },
  setup() {
    const spacesStore = useSpacesStore();
    const dataRequest = ref(true);
    const shortList = computed(() => spacesStore.groupsByOwnerId.slice(0, 2));
    onMounted(() => {
      spacesStore.fetchUserParticipatedGroups().finally(() => { dataRequest.value = false; });
    });
    function goViewMyOwnGroups() {
      router.push('/spaces/groups/view-my-own');
    }
    function viewParticipatedGroups() {
      router.push('/spaces/groups/you-are-in');
    }

    onUnmounted(() => {
      spacesStore.search = '';
    });
    return {
      dataRequest,
      shortList,
      spacesStore,
      goViewMyOwnGroups,
      viewParticipatedGroups,
    };
  },
});
